import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface ShowAndHidePinProps {
  pin: string;
  setPin: (value: string) => void;
  containerStyles?: string;
}

export const ShowAndHidePin = ({
  pin,
  setPin,
  containerStyles,
}: ShowAndHidePinProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={`w-full mb-5 relative flex flex-row bg-melon-light-grey rounded-lg h-12 text-center  ${containerStyles}`}
    >
      <input
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        type={visible ? "text" : "password"}
        autoComplete="new-password"
        placeholder="ПИН-код*"
        className="bg-melon-light-grey rounded-lg h-12 text-center w-full focus:outline-none text-melon-black "
      />
      <div
        onClick={() => setVisible(!visible)}
        className=" absolute right-0 p-4 flex justify-between items-center cursor-pointer"
      >
        {visible ? <FaEye color="black" /> : <FaEyeSlash color="black" />}
      </div>
    </div>
  );
};
